"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRateForInsurance = void 0;
const common_1 = require("../../../common");
const rate_filters_1 = require("./rate-filters");
const INDICATOR_OF_ALL_STATES = common_1.State.All;
function getRateForInsurance(options, rates, ageReplacementRules = []) {
    const availableRates = rate_filters_1.filterRatesByProductAndCommission(rates, options.product, options.commission);
    const state = hasStateSpecificRates(availableRates, options.state) ? options.state : INDICATOR_OF_ALL_STATES;
    const stateRates = rate_filters_1.filterRatesByState(availableRates, state);
    const ageRates = rate_filters_1.filterRatesByAge(stateRates, options, ageReplacementRules);
    if (ageRates.length > 1) {
        throw new Error(`Found multiple rates matching ${JSON.stringify(options)}.`);
    }
    return ageRates[0];
}
exports.getRateForInsurance = getRateForInsurance;
function hasStateSpecificRates(rates, state) {
    return rates.some(rate => rate.state === state);
}
//# sourceMappingURL=rates-filterer.js.map